import React, {useEffect} from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import {useLocation, useNavigate} from "react-router-dom";
import StripeCheckoutFormStyled from "../../payments/StripeCheckoutFormStyled";

export default function LandingFormCheckoutVT() {
    let navigate = useNavigate();
    const {state} = useLocation();

    useEffect(() => {
        const venueId = state?.venueId;
        const packageId = state?.packageId;

        if (!packageId || !venueId) {
            navigate('/login/mobile', {replace: true});
        }

        return function cleanup() {

        };
    }, []);

    return (
        <>
            <Header headerType="UserOnly"/>
            <StripeCheckoutFormStyled venueId={state?.venueId} packageId={state?.packageId}/>
            <Footer/>
        </>
    );
}